import CommandManager from '../managers/command-manager';
import elt from '../html/elt';
import injectCSS from '../html/inject-css';
import logging from '../logging';

const log = logging('components');

/**
 * Dispatches a global CustomEvent when clicked. The type of the command can be
 * configured by the "action" attribute.
 */
export default class CommandToggle extends HTMLElement{

    connectedCallback() {
        injectCSS(STYLESHEET);
        this.classList.add('form-check');
        const toggle: HTMLInputElement =
            elt( 'input', {type: 'checkbox', class: 'form-check-input'});
        const label = elt('label', {class: 'form-check-label'});

        toggle.checked = this.hasAttribute('checked');

        const onChange = () => {
            if(toggle.checked) {
                this.setAttribute('checked', '');
            } else {
                this.removeAttribute('checked');
            }

            const
                action = String(this.getAttribute('action')),
                channel = this.getAttribute('channel') ?? 'app-command';
            log.debug(`CommandToggle.click ${action}`);
            CommandManager.do(channel, action, toggle.checked);
        }
        toggle.addEventListener('change', onChange);

        label.addEventListener('click', () => {
            toggle.checked = !toggle.checked;
            onChange();
        });

        label.innerText = this.innerText;
        this.replaceChildren(); // clear our contents

        this.append(toggle);
        this.append(label);
    }
}
window.customElements.define('command-toggle', CommandToggle);
log.debug('Defined custom element <command-toggle>');


const STYLESHEET = `
command-toggle, command-toggle.form-check {
    display: inline-block;
    cursor: pointer;

    &[disabled] INPUT {
        pointer-events: none;
        color: gray;
    }

    &, & INPUT, & LABEL
        user-select: none;
    }
}
`;
